<div *ngIf="institution" class="institution-card">
  <div class="institution-card__header">
    <button *ngIf="!showConfirm && saved && showRemove" (click)="confirmRemove($event)" class="close-btn" mat-icon-button>
      <mat-icon class="remove-icon" svgIcon="close-icon"></mat-icon>
    </button>
    <div class="institution-card__title">
      {{ institution.name }}
    </div>
    <div class="institution-card__sub-title">
      {{ institution.city }}, {{ institution.state }}
      <ng-container *ngIf="institution.institutionLevel">
        &bull; {{ institution.institutionLevel }} Year
      </ng-container>
    </div>
  </div>
  <div class="institution-card__body">
    <div *ngIf="showConfirm" class="confirmation">
      <div class="confirmation__title">Remove institution from your saved list?</div>
      <div class="d-flex gap-md justify-content-center">
        <button (click)="remove($event)" mat-flat-button color="primary">Remove</button>
        <button (click)="cancelRemove($event)" mat-stroked-button color="primary">Cancel</button>
      </div>
    </div>
    <ng-container *ngIf="!showConfirm">
      <div class="d-flex gap-sm">
        <div *ngIf="institution.hasDistance" class="d-flex gap-xs">
          <div class="card__icon">
            <mat-icon svgIcon="computer-icon"></mat-icon>
          </div>
          <div class="card__label">Distance</div>
        </div>
        <div *ngIf="institution.hasInPerson" class="d-flex gap-xs">
          <div class="card__icon">
            <mat-icon svgIcon="book-icon"></mat-icon>
          </div>
          <div class="card__label">In Person</div>
        </div>
      </div>
      <div class="d-flex gap-xs">
        <div class="card__icon">
          <mat-icon svgIcon="graduate-icon"></mat-icon>
        </div>
        <div></div>
        <div class="card__label">
          {{ institution.acceptanceRate || 0 | number : '1.0-2' }}% Acceptance Rate
        </div>
      </div>
      <div class="d-flex gap-xs">
        <div class="card__icon">
          <mat-icon svgIcon="users-icon"></mat-icon>
        </div>
        <div></div>
        <div class="card__label">
          {{ institution.taParticipants | number : '1.0-2' }} TA Participants
        </div>
      </div>
      <div class="achievement-tests">
        <div class="test">
          <div class="test__name">SAT/ACT</div>
          <div class="test__icon">
            <img
              src="assets/images/institution/{{ institution.testScore ? 'yes' : 'no' }}.svg"
              alt="" />
          </div>
          <div class="test__value">
            {{ institution.testScore ? 'Yes' : 'No' }}
          </div>
        </div>
        <div class="test">
          <div class="test__name">Transcript</div>
          <div class="test__icon">
            <img
              src="assets/images/institution/{{ institution.transcript ? 'yes' : 'no' }}.svg"
              alt="" />
          </div>
          <div class="test__value">
            {{ institution.transcript ? 'Yes' : 'No' }}
          </div>
        </div>
      </div>

      <div class="institution-card__actions">
        <button
          (click)="saved ? confirmRemove($event) : save($event)"
          mat-flat-button
          color="primary"
          class="px-sm m-0">
          <mat-icon class="save-icon" [svgIcon]="saved ? 'saved-icon' : 'save-icon'"></mat-icon>
          {{ saved ? 'Saved' : 'Save' }}
        </button>
        <button
          (click)="added ? removeFromCompare($event) : addToCompare($event)"
          mat-flat-button
          color="primary"
          class="px-sm m-0">
          <mat-icon class="add-icon" [svgIcon]="added ? 'minus-icon' : 'add-icon'"></mat-icon>
          {{ added ? 'Added to Compare' : 'Add to Compare' }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
